<form
  [formGroup]='formGroup'
  class='widget'
>
  <div class='form-group form-group-ng-select'>
    <pt-input-label
      *ngIf='label'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <div
      [ngClass]="{'is-invalid': formGroup.invalid}"
      class='form-control form-control-sm ng-select-single-control'>
<!--      [class.is-invalid]='formGroup.invalid && formGroup.touched'-->
<!--      [class.ng-dirty]=formGroup.dirty-->
<!--      [class.ng-invalid]='formGroup.invalid && formGroup.touched'-->
<!--      [class.ng-touched]=formGroup.touched-->
<!--      [class.ng-valid]=formGroup.valid-->
      <ng-select
        [clearable]='clearable'
        [id]='inputId'
        [items]='options.items'
        [notFoundText]='notFoundText'
        [placeholder]='placeholder'
        [readonly]='disabledControl'
        appendTo='body'
        bindLabel='{{options.bindLabel}}'
        bindValue='{{options.bindValue}}'
        formControlName='value'
      ></ng-select>
    </div>
    <small
      [innerHTML]='help'
      class='form-text text-muted' id='ptWFilteredSelectHelp_{{controlName}}'
    ></small>
  </div>
</form>
